import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  buttoncountcontainer: {
    marginTop: 15,
    marginBottom: 15
  },
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  rightcont: {
    position: "relative",
    backgroundColor: "white",
    height: "calc(100vh - 300px)",
    boxSizing: "border-box",
    padding: "24px 15px 0px 15px",
    overflow: "scroll"
  },
  exportbtn: {
    // maxWidth: "190px",
    // position: "absolute",
    position: "sticky",
    bottom: "0px",
    left: "18px",
    right: "19px",
    margin: "0 auto"
  },
  buttons: {
    maxWidth: "300px",
    margin: "18px auto"
  },
  savebtn: {
    maxWidth: "150px",
    margin: "18px auto"
  },
  notedetails: {
    height: "100%",
    overflow: "scroll",
    "& h4": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "14px",
      color: "black",
      textAlign: "left"
    },
    "& h5": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "11.33px",
      color: "#6C737F",
      textAlign: "left"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "9.71px",
      color: "#6C737F",
      marginBlock: "0px",
      textAlign: "left"
    },
    "@media (max-width: 900px)": {
      height: "100%"
    }
  },
  notespan: {
    marginTop: "10px",
    marginBottom: "10px",
    "& h5": {
      fontWeight: "700",
      marginBlock: "0px",
      fontSize: "15px",
      color: "#6C737F",
      textAlign: "left"
    },
    "& p": {
      fontWeight: 400,
      fontSize: "12px",
      color: "#6C737F",
      marginBlock: "0px",
      textAlign: "left"
    }
  },
  textarea: {
    border: "none",
    height: "70px",
    width: "100%"
  },
  fortextarea: {
    border: "1px solid #F0F2F5",
    padding: "16px",
    borderRadius: "9px",
    marginTop: "5px"
  },
  commentarea: {
    textAlign: "left",
    padding: "16px",
    border: "1px solid #F0F2F5",
    fontSize: "14px"
  },
  verticalline: {
    paddingLeft: 15,
    paddingBottom: 5,
    textAlign: "left"
  },
  parsercont: {
    textAlign: "left",
    "& ul": {
      listStyle: "initial",
      paddingLeft: "24px"
    }
  },
  overallcont: {
    paddingLeft: "11px",
    cursor: "pointer",
    "& h3": {
      fontWeight: "500",
      fontSize: "18px",
      letterSpacing: "-0.3px",
      marginBlock: "0px",
      textAlign: "left",
      textDecoration: "none"
    },
    "& hr": {
      width: "90%",
      border: "0.1px solid #BAC1CC",
      float: "left",
      marginBlock: "26px 18px"
    }
  },
  cardcontent: {
    textAlign: "left",
    fontSize: "14px",
    maxHeight: "70px",
    overflow: "hidden",
    "& h1": {
      fontSize: "14px",
      fontWeight: 400,
      textAlign: "left",
      marginBlock: "0px"
    },
    "& p": {
      fontSize: "14px",
      fontWeight: 400,
      color: "#667185",
      textAlign: "left",
      marginBlock: "0px"
    },
    "& h3": {
      fontSize: "14px",
      fontWeight: 400,
      color: "#667185",
      textAlign: "left",
      marginBlock: "0px"
    },
    "& h2": {
      fontSize: "14px",
      fontWeight: 400,
      color: "#667185",
      textAlign: "left",
      marginBlock: "0px"
    }
  },
  submitreview: {
    "& p": {
      fontWeight: 500,
      fontSize: "12px",
      color: "#0065FF"
    }
  },
  paddingcont: {
    position: "relative",
    background: "white",
    paddingBlock: "32px",
    "@media (max-width: 590px)": {
      paddingBlock: "14px"
    }
  },
  cardfooter: {
    marginTop: "18px"
  },
  lessondate: {
    "& h4": {
      fontWeight: 500,
      fontSize: "14px",
      color: "#6C737F",
      textAlign: "left",
      marginBlock: "0px"
    }
  },
  loweritems: {
    height: "50px"
  },
  reload: {
    position: "absolute",
    right: "16px",
    top: "35px",
    cursor: "pointer",
    color: theme.palette.primary.main,
    "& svg": {
      color: theme.palette.primary.main,
      fill: theme.palette.primary.main
    }
  },
  custom: {
    marginTop: 20,
    background: "#fff",
    padding: "20px",
    borderRadius: 12
  },

  customheading: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 20,

    "& h3": {
      margin: 0,
      fontSize: 18,
      fontWeight: 600,
      textAlign: "left"
    },

    "& p": {
      margin: 0,
      fontSize: 13,
      color: "#777"
    }
  },

  emptyStateBox: {
    border: "1px dashed #d0d7de",
    borderRadius: 12,
    padding: "60px 20px",
    textAlign: "center",
    color: "#667085",

    "& img": {
      width: 110,
      opacity: 0.5,
      marginBottom: 10
    },

    "& h4": {
      margin: "10px 0 4px",
      fontWeight: 600,
      fontSize: 16
    },

    "& p": {
      fontSize: 13
    }
  },
  titlebtn: {
    display: "flex",
    marginTop: "16px",
    gap: "10px",
    "@media (max-width: 380px)": {
      flexDirection: "column"
    }
  },
  luluSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "18px 0"
  },
  luluContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    "& img": {
      width: 65
    },
    "& p": {
      color: "#0065FF",
      fontWeight: 600,
      fontSize: 13,
      marginTop: 4,
      marginBottom: 0
    }
  },
  exportIconBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: "white",
    border: `1.5px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    padding: 0,
    "&:hover": {
      backgroundColor: "#E6F0FF"
    }
  },
  editIconBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: 8,
    cursor: "pointer",
    backgroundColor: theme.palette.primary.main,
    border: `1.5px solid ${theme.palette.primary.main}`,
    color: "white",
    padding: 0,
    "&:hover": {
      opacity: 0.9
    }
  },
  generateDrawerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    paddingBottom: 16,
    marginBottom: 20,
    borderBottom: "1px solid #E4E7EC"
  },
  generateDrawerTitle: {
    margin: 0,
    fontSize: 20,
    fontWeight: 700,
    color: "#101828"
  },
  generateDrawerSubtitle: {
    margin: "4px 0 0",
    fontSize: 14,
    fontWeight: 400,
    color: "#667085"
  },
  generateDrawerContextTitle: {
    margin: "4px 0 0",
    fontSize: 14,
    fontWeight: 600,
    color: "#101828"
  },
  generateMetaBadges: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    marginTop: 10
  },
  generateMetaBadge: {
    display: "inline-flex",
    alignItems: "center",
    padding: "4px 10px",
    borderRadius: 999,
    fontSize: 12,
    fontWeight: 500,
    color: "#344054",
    backgroundColor: "#F2F4F7",
    border: "1px solid #E4E7EC"
  },
  generateDrawerClose: {
    backgroundColor: "#101828 !important",
    width: 28,
    height: 28,
    "&:hover": {
      backgroundColor: "#344054 !important"
    }
  },
  generateDrawerBody: {
    flex: 1,
    overflowY: "auto",
    paddingBottom: 16
  },
  generateFieldRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 16,
    marginBottom: 20
  },
  generateRadioSection: {
    marginBottom: 20
  },
  generateRadioLabel: {
    margin: "0 0 10px",
    fontSize: 14,
    fontWeight: 500,
    color: "#344054"
  },
  generateRadioGroup: {
    display: "flex",
    flexWrap: "wrap",
    gap: 16,
    alignItems: "center"
  },
  generateRadioOption: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    cursor: "pointer",
    fontSize: 14,
    color: "#101828",
    "& input[type='radio']": {
      accentColor: theme.palette.primary.main,
      width: 16,
      height: 16,
      margin: 0,
      cursor: "pointer"
    }
  },
  generateEmptyState: {
    marginTop: 8,
    fontSize: 13,
    color: "#667085"
  },
  generateDrawerFooter: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    paddingTop: 16,
    borderTop: "1px solid #E4E7EC",
    marginTop: "auto"
  },
  generateResultsMeta: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 16,
    paddingBottom: 12,
    borderBottom: "1px solid #E4E7EC"
  },
  generateResultsCount: {
    margin: 0,
    fontSize: 14,
    fontWeight: 600,
    color: "#101828"
  },
  generateEditSetup: {
    border: "none",
    background: "transparent",
    padding: 0,
    cursor: "pointer",
    fontSize: 14,
    fontWeight: 600,
    color: theme.palette.primary.main,
    "&:hover": {
      textDecoration: "underline"
    }
  },
  generateDestinationEditor: {
    maxHeight: 0,
    overflow: "hidden",
    transition: "max-height 0.25s ease",
    marginBottom: 0
  },
  generateDestinationEditorOpen: {
    maxHeight: 420,
    marginBottom: 16
  },
  generateDestinationEditorInner: {
    padding: "16px",
    borderRadius: 12,
    border: "1px solid #E4E7EC",
    backgroundColor: "#F9FAFB"
  },
  generateDestinationNotice: {
    margin: "0 0 16px",
    fontSize: 13,
    lineHeight: 1.5,
    color: "#667085"
  },
  generateQuestionsList: {
    display: "flex",
    flexDirection: "column",
    gap: 12
  },
  generateQuestionCard: {
    border: "1px solid #E4E7EC",
    borderRadius: 12,
    padding: 16,
    backgroundColor: "#fff"
  },
  generateQuestionCardHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: 12,
    marginBottom: 12
  },
  generateQuestionText: {
    margin: 0,
    fontSize: 14,
    fontWeight: 600,
    color: "#101828",
    lineHeight: 1.45,
    flex: 1
  },
  generateQuestionActions: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    flexShrink: 0
  },
  generateQuestionActionBtn: {
    padding: "4px !important"
  },
  generateOptionsList: {
    display: "flex",
    flexDirection: "column",
    gap: 8
  },
  generateOptionRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    borderRadius: 8,
    border: "1px solid transparent"
  },
  generateOptionRowSelected: {
    backgroundColor: "#EFF6FF",
    borderColor: "#BFDBFE"
  },
  generateOptionControl: {
    display: "inline-flex",
    color: "#98A2B3",
    flexShrink: 0
  },
  generateOptionControlSelected: {
    color: theme.palette.primary.main
  },
  generateOptionText: {
    fontSize: 14,
    color: "#344054",
    lineHeight: 1.4
  },
  generateResultsFooter: {
    paddingTop: 16,
    borderTop: "1px solid #E4E7EC",
    marginTop: "auto"
  }
}));
